"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdFormik = require("cccisd-formik");
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _FilterTags = _interopRequireDefault(require("../FilterTags"));
var _IconPicker = _interopRequireDefault(require("../IconPicker"));
var _cccisdColorPicker = _interopRequireWildcard(require("cccisd-color-picker"));
var _generateNewId = require("../../../../../../helpers/generateNewId");
var _reorder = _interopRequireDefault(require("../../../../../../helpers/reorder.js"));
var _style = _interopRequireDefault(require("./style.css"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _shrink = _interopRequireDefault(require("cccisd-icons/shrink7"));
var _enlarge = _interopRequireDefault(require("cccisd-icons/enlarge7"));
var _arrowUp = _interopRequireDefault(require("cccisd-icons/arrow-up"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } // Icons
var TabForm = function TabForm(props) {
  var currentTab = props.currentTab,
    allTags = props.allTags,
    icons = props.icons,
    filterGroupIcons = props.filterGroupIcons;
  var label = currentTab.label,
    filterGroups = currentTab.filterGroups,
    topFilterBar = currentTab.topFilterBar,
    icon = currentTab.icon,
    tag = currentTab.tag;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var onDragEnd = function onDragEnd(result) {
    var destination = result.destination,
      source = result.source;
    if (!destination) {
      return;
    }
    (0, _reorder["default"])(currentTab.filterGroups, source.index, destination.index);
  };
  var collapseAll = function collapseAll() {
    setCollapsed(filterGroups.map(function (filterGroup) {
      return filterGroup.id.value;
    }));
  };
  var expandAll = function expandAll() {
    setCollapsed([]);
  };
  var handleCollapse = function handleCollapse(id) {
    setCollapsed((0, _xor2["default"])(collapsed, [id]));
  };
  var _renderMenu = function _renderMenu(filterGroup, filterGroupIndex) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].filterGroupMenu
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      onClick: function onClick() {
        return handleCollapse(filterGroup.id.value);
      },
      className: "btn btn-default btn-xs"
    }, collapsed.includes(filterGroup.id.value) ? /*#__PURE__*/_react["default"].createElement(_enlarge["default"], null) : /*#__PURE__*/_react["default"].createElement(_shrink["default"], null)), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      title: /*#__PURE__*/_react["default"].createElement(_cross["default"], null),
      className: "btn btn-danger btn-xs",
      isConfirm: true,
      confirmationMessage: "Are you sure you want to delete this filter group: ".concat(filterGroup.name.value, "?"),
      onClick: function onClick() {
        filterGroups.removeField(filterGroupIndex);
      }
    }));
  };
  var getListStyle = function getListStyle(isDraggingOver) {
    return {
      background: isDraggingOver ? '#fbfdfe' : '#fff',
      overflow: 'auto'
    };
  };
  var getItemStyle = function getItemStyle(isDragging) {
    return {
      userSelect: 'none',
      background: isDragging ? '#f0f0f0' : ''
    };
  };
  var handleAddNewFilterGroup = function handleAddNewFilterGroup() {
    filterGroups.addField({
      id: (0, _generateNewId.generateNewId)({
        prefix: 'filterGroup',
        settings: filterGroups.map(function (group) {
          return {
            id: group.id.value
          };
        })
      }),
      name: 'New Filter Group',
      collapsible: true,
      isCollapsed: false,
      tags: [],
      icon: '',
      color: ''
    });
  };
  var handleAddSessionTag = function handleAddSessionTag(values) {
    if (values.sessionTag) {
      topFilterBar.tags.addField(values.sessionTag);
    }
  };
  var existingTags = topFilterBar.tags.map(function (t) {
    return t.value;
  });
  var tagOptions = allTags.filter(function (t) {
    return !existingTags.includes(t.name);
  }).map(function (t) {
    return {
      value: t.name,
      label: t.label
    };
  });
  tagOptions.unshift({
    value: '',
    label: '-- Choose Tag --'
  });
  var getSessionTagName = function getSessionTagName(tagValue) {
    var tagLabel = allTags.find(function (t) {
      return t.name === tagValue;
    }).label;
    if (tagLabel !== tagValue) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          fontWeight: 'bold'
        }
      }, tagLabel), " (", tagValue, ")");
    }
    return /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, tagLabel);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "panel"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: label
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "Tab label is what is displayed in the Resource Center. You can leave this blank if you don't want text to appear in the tab."
  }, "Tab label ", /*#__PURE__*/_react["default"].createElement(_question["default"], null))), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.WysiwygEditor, {
    key: currentTab.id.name,
    field: label,
    type: "input",
    settings: {
      toolbar: ['bold italic underline | code cccisdIcons']
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-4"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: tag,
    required: true,
    label: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Tab tag is used to associate resources with this tab. It's name should be unique for this Resource Center. Choose from a list of tags that are created above, in the Tags menu."
    }, "Tab tag ", /*#__PURE__*/_react["default"].createElement(_question["default"], null))
  }, /*#__PURE__*/_react["default"].createElement("select", _extends({
    className: "form-control"
  }, (0, _cccisdReduxFormHelpers.domOnlyProps)(tag), {
    style: {
      width: 'auto'
    }
  }), allTags.map(function (t) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      value: t.name,
      key: t.id
    }, t.name);
  })))), icon.value !== '' && /*#__PURE__*/_react["default"].createElement(_IconPicker["default"], {
    label: "Tab Icon",
    field: icon,
    icons: icons
  })), /*#__PURE__*/_react["default"].createElement("h4", null, "Filters for", ' ', /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      display: 'inline-block'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: label.value
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].sessionFilters
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontWeight: 'bold',
      marginBottom: '0.5em'
    }
  }, "Session Filters"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '0.5em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: topFilterBar.showTopFilterBar.value,
    onChange: function onChange() {
      return topFilterBar.showTopFilterBar.onChange(!topFilterBar.showTopFilterBar.value);
    },
    label: "Show Session Filters?"
  })), topFilterBar.showTopFilterBar && topFilterBar.showTopFilterBar.value && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      maxWidth: '300px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    label: "Title",
    field: topFilterBar.title
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].sessionFilterTags
  }, topFilterBar.tags.map(function (filterTag, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].sessionFilterTag,
      key: filterTag.value
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].sessionFilterTagValue
    }, getSessionTagName(filterTag.value)), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        padding: '0.5em'
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      title: /*#__PURE__*/_react["default"].createElement(_cross["default"], null),
      className: "btn btn-danger btn-xs",
      onClick: function onClick() {
        topFilterBar.tags.removeField(index);
      }
    })));
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    onSubmit: handleAddSessionTag,
    render: function render() {
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "sessionTag",
        component: _cccisdFormik.CccisdSelect,
        label: "Add Session Tag",
        options: tagOptions
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-primary",
        type: "submit"
      }, "Add Session Tag"))));
    }
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].collapseButtons
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-primary btn-xs",
    onClick: collapseAll,
    style: {
      marginRight: '1em'
    }
  }, "Collapse All"), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-primary btn-xs",
    onClick: expandAll
  }, "Expand All")), /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "droppable"
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, provided.droppableProps, {
      ref: provided.innerRef,
      style: getListStyle(snapshot.isDraggingOver),
      className: _style["default"].droppable
    }), filterGroups.map(function (filterGroup, filterGroupIndex) {
      return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
        draggableId: filterGroup.id.value,
        index: filterGroupIndex,
        key: filterGroup.id.value
      }, function (dragProvided, dragSnapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          key: filterGroup.id.value,
          ref: dragProvided.innerRef
        }, dragProvided.draggableProps, {
          className: "container-fluid well ".concat(_style["default"].filterTag)
        }), /*#__PURE__*/_react["default"].createElement("div", _extends({
          className: _style["default"].dragHandle
        }, dragProvided.dragHandleProps, {
          style: getItemStyle(dragSnapshot.isDragging, dragProvided.draggableProps.style)
        }), /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], null), /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'block',
            width: '100%',
            padding: '1em'
          }
        }, _renderMenu(filterGroup, filterGroupIndex), collapsed.includes(filterGroup.id.value) ? filterGroup.name.value : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
          className: "row"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-md-3"
        }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
          value: filterGroup.collapsible.value,
          onChange: function onChange() {
            return filterGroup.collapsible.onChange(!filterGroup.collapsible.value);
          },
          label: "Collapsible"
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-md-3"
        }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
          value: filterGroup.isCollapsed.value,
          onChange: function onChange() {
            return filterGroup.isCollapsed.onChange(!filterGroup.isCollapsed.value);
          },
          label: "Collapse by default"
        }))), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginRight: '1em'
          }
        }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
          field: filterGroup.name,
          label: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: "Filter Group Name acts as a tag and must be defined in Tags."
          }, "Filter Group Name ", /*#__PURE__*/_react["default"].createElement(_question["default"], null))
        }, /*#__PURE__*/_react["default"].createElement("select", _extends({
          className: "form-control"
        }, (0, _cccisdReduxFormHelpers.domOnlyProps)(filterGroup.name), {
          style: {
            width: 'auto'
          }
        }), allTags.map(function (t) {
          return /*#__PURE__*/_react["default"].createElement("option", {
            value: t.name,
            key: t.id
          }, t.label === t.name ? t.label : "".concat(t.label, " (").concat(t.name, ")"));
        })))), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginRight: '1em'
          }
        }, /*#__PURE__*/_react["default"].createElement(_IconPicker["default"], {
          label: "Filter Group Icon",
          field: filterGroup.icon,
          icons: filterGroupIcons,
          style: {
            bottom: '-60px'
          }
        })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
          field: filterGroup.color,
          label: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: "This color will override the 'Filter Collapse Color' setting when using an icon. If you dont want to override this color setting, set the icon to 'No Icon'."
          }, "Filter Group & Icon Color", ' ', /*#__PURE__*/_react["default"].createElement(_question["default"], null))
        }, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
          value: filterGroup.color.value,
          onChange: function onChange(c) {
            return filterGroup.color.onChange((0, _cccisdColorPicker.getColor)(c));
          }
        })))), /*#__PURE__*/_react["default"].createElement("div", {
          className: "row"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "col-md-8"
        }, /*#__PURE__*/_react["default"].createElement(_FilterTags["default"], {
          filterGroup: filterGroup,
          allTags: allTags
        }))))));
      });
    }), provided.placeholder, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-default",
      onClick: handleAddNewFilterGroup
    }, "Add New Filter Group"));
  })));
};
var _default = exports["default"] = TabForm;